module.exports = ".sin-registros {\r\n    margin: 40px 0px;\r\n}\r\n\r\n.erroneo{\r\n    background-color: red;\r\n    color: white;\r\n}"